/** ISO YYYY-MM-DD ou JJ/MM/AAAA (réponses API / affichage). */
export function parseFgasLocalYmd(raw: string): Date | null {
  const s = raw.trim()
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (iso) {
    const y = Number(iso[1])
    const mo = Number(iso[2]) - 1
    const d = Number(iso[3])
    const dt = new Date(y, mo, d)
    if (dt.getFullYear() !== y || dt.getMonth() !== mo || dt.getDate() !== d) {
      return null
    }
    return dt
  }
  const fr = s.match(/^(\d{2})\/(\d{2})\/(\d{4})/)
  if (fr) {
    const d = Number(fr[1])
    const mo = Number(fr[2]) - 1
    const y = Number(fr[3])
    const dt = new Date(y, mo, d)
    if (dt.getFullYear() !== y || dt.getMonth() !== mo || dt.getDate() !== d) {
      return null
    }
    return dt
  }
  return null
}

/** Expirée ou fin = jour civil local → non utilisable pour une commande. */
export function isFgasEndDateExpiredOrToday(endDateRaw: string): boolean {
  const end = parseFgasLocalYmd(endDateRaw)
  if (!end) return false
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  end.setHours(0, 0, 0, 0)
  return end <= today
}

export function isFgasStartStrictlyBeforeEnd(
  startRaw: string,
  endRaw: string
): boolean {
  const start = parseFgasLocalYmd(startRaw)
  const end = parseFgasLocalYmd(endRaw)
  if (!start || !end) return false
  return start < end
}

export function isValidFgasSiret(raw: string): boolean {
  return /^\d{14}$/.test(raw.trim())
}

export function isValidFgasFrenchPostalCode(raw: string): boolean {
  return /^\d{5}$/.test(raw.trim())
}
